import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  issueTypes: null,
}

const getters = {
  issueTypes() {
    return axios.get(`/IssueType`)
  },
}

export default class IssueTypeService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
